import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store';

import GameLeftSide from '../gameLeftSide';
import GameRightSide from '../gameRightSide';
import GameCenterSide from '../gameCenterSide';
import { gameDrawer } from '../../game/drawers';

export const GameContent = observer(() => {
  const ref = useRef();
  const { endedFreeBets } = freeBetStore;

  useEffect(() => {
    if (!ref.current) return;
    gameDrawer.setupRoot(ref.current);
  }, [ref.current]);

  useEffect(() => {
    if (endedFreeBets.length) {
      freeBetStore.handleFreeBetEndedData();
    }
  }, [endedFreeBets.length]);

  return (
    <div className='crazy-worm-wrapper'>
      <div ref={ref} />
      <GameLeftSide />
      <GameCenterSide />
      <GameRightSide />
    </div>
  );
});
